export const SITE_URL = "https://playlist-portal-4.preview.emergentagent.com";

export const BRAND_NAME = "deep end grooves";
export const BRAND_NAME_LONG = "deep end grooves";
export const TAGLINE = "everything deep — all the time";

export const SPOTIFY_URL = "https://open.spotify.com/playlist/0PT6m80Ep88pTYTbYxVeZ4";
export const SPOTIFY_EMBED =
    "https://open.spotify.com/embed/playlist/0PT6m80Ep88pTYTbYxVeZ4?utm_source=generator&theme=0";
export const APPLE_URL = "https://music.apple.com/us/playlist/deep-end-grooves/pl.u-pMyl1BMC4Yz48xy";
export const SOUNDCLOUD_URL = "https://soundcloud.com/deep-end-grooves";
export const INSTAGRAM_URL = "https://www.instagram.com/deependgrooves/";
export const INSTAGRAM_HANDLE = "@deependgrooves";

export const COVER_ART = "https://image-cdn-ak.spotifycdn.com/image/ab67706c0000da84752b2576bb1f9a02d20aaa25";

export const NAV = [
    { label: "what this is", short: "about", href: "#about" },
    { label: "the playlist", short: "playlist", href: "#playlists" },
    { label: "submit a track", short: "submit", href: "#submit" },
    { label: "follow", short: "follow", href: "#follow" },
];

export const GENRES = [
    { value: "deep house", label: "deep house" },
    { value: "deep tech", label: "deep tech" },
    { value: "minimal deep tech", label: "minimal deep tech" },
    { value: "dub techno", label: "dub techno" },
    { value: "dub lounge", label: "dub lounge" },
    { value: "other", label: "other" },
];

export const FAQS = [
    {
        q: "how do i submit music to a deep house playlist?",
        a: "use the form above. one track at a time, with a streamable link from spotify, apple music or soundcloud. every submission gets listened to.",
    },
    {
        q: "can i pitch an unreleased track for pre-save?",
        a: "yes. pick unreleased on the form, give the release date and a pre-save or private streaming link. send it with enough lead time to be useful — a track that lands tomorrow rarely does.",
    },
    {
        q: "what does deependgrooves cover?",
        a: "deep house, deep tech and minimal deep tech, dub techno and dub lounge. the scope is deliberately narrow.",
    },
    {
        q: "how often is the playlist updated?",
        a: "weekly. new additions go in at the top and the playlist gets pruned regularly so it stays listenable end to end.",
    },
    {
        q: "where else can i hear the selection?",
        a: "apple music and soundcloud carry the same selection. the apple music and soundcloud playlists follow the spotify playlist.",
    },
    {
        q: "will i hear back about my submission?",
        a: "only if the track goes in. everything is listened to, but there is no capacity to reply to every submission.",
    },
];
